import styled from '@emotion/styled';
import { COLOR_VARIANTS, color } from '@tajawal/ct-web-design-system';

const ErrorPageWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: ${color(COLOR_VARIANTS.WHITE)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  z-index: 100;
  padding: 16px;
`;

export default {
  ErrorPageWrapper,
};
